import { Logo } from "./Logo";

export const Footer = () => (
  <footer className="bg-emerald-950 text-emerald-100 mt-24">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-14 grid grid-cols-1 sm:grid-cols-4 gap-10">
      <div className="sm:col-span-2">
        <div className="[&_span]:text-white"><Logo light /></div>
        <p className="mt-4 text-emerald-300/80 max-w-sm text-sm leading-relaxed">
          Dein Event-Catering & Entertainment in Minuten gebucht. Pizzawagen, DJ, Cocktailbar & mehr für Hochzeit, Geburtstag, Firmenfeier.
        </p>
      </div>
      <div>
        <h4 className="font-semibold text-white mb-3">Kategorien</h4>
        <ul className="space-y-2 text-sm text-emerald-300/80">
          <li>Pizzawagen</li><li>DJ & Musik</li><li>Cocktailbar</li><li>Fotobox</li>
        </ul>
      </div>
      <div>
        <h4 className="font-semibold text-white mb-3">Anlässe</h4>
        <ul className="space-y-2 text-sm text-emerald-300/80">
          <li>Hochzeit</li><li>Geburtstag</li><li>Firmenfeier</li><li>Jubiläum</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-emerald-900 py-5 text-center text-xs text-emerald-400/70">
      © {new Date().getFullYear()} eventimo.online · Alle Rechte vorbehalten
    </div>
  </footer>
);
